import $ from 'jquery'
import 'select2'

export default () => {
  $('.init-select2').each((index, element) => {
    const { placeholder } = element.dataset
    $(element).select2({
      minimumResultsForSearch: -1,
      placeholder,
      dropdownParent: $(element).parents('.select2-parent')
    });
  })
}


// WEBPACK FOOTER //
// app/scripts/components/select2.js